export const environment = {
  production: true,
  legacyUrl: "https://uat-appx4.visiblealpha.com/app",
  legacyDomain: "https://uat-appx4.visiblealpha.com",
  apiUrl: "https://uat-appx4-insights.visiblealpha.com",
  sellsideApiUrl: "https://uat-appx4-insights.visiblealpha.com",
  assetUrl: "https://uat-cafe-cdn.visiblealpha.com/page/assets",
  showReportCenter: true,
  showZendesk: true,
  datadogRum: {
    active: false,
  },
  SUPPORT_LINKS: {
    base_link: "https://support-omega.visiblealpha.com",
    en_US: "/s/article",
    articles: {
      reaffirmed_in_consensus: "/reaffirmed-transactions-in-current-consensus",
      calendarization_methods: "/calendarization-methods",
      rolling_periods_calculation_methods:
        "/ltm-ntm-and-stm-calculation-methods",
      target_price_rating_concensus_calc:
        "/getting-started-with-insights-target-price-and-ratings-for-the-sell-side",
      target_price_rating_normalization:
        "/getting-started-with-insights-target-price-and-ratings-for-the-sell-side",
      sli_methodology: "/primary-standardized-line-item-sli-methodology",
    },
  },
};
